import { render, staticRenderFns } from "./SendReports.vue?vue&type=template&id=4ea48e46&scoped=true"
import script from "./SendReports.vue?vue&type=script&lang=js"
export * from "./SendReports.vue?vue&type=script&lang=js"
import style0 from "./SendReports.vue?vue&type=style&index=0&id=4ea48e46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea48e46",
  null
  
)

export default component.exports